import { SimpleLogoPageContainer } from '@/components/shared/SimpleLogoPageContainer'
import { Stack, Text } from '@/components/ui'

export const UnexpectedErrorPage = () => {
  return (
    <SimpleLogoPageContainer centered showVersion={false}>
      <Stack align="center" color="blue.600" gap="4">
        <Text fontSize="xl" lineHeight="1" fontWeight="semibold">
          問題が発生しました
        </Text>
        <Text>時間を置いて再度お試しください</Text>
      </Stack>
    </SimpleLogoPageContainer>
  )
}
